/// <reference path="../../../../typings/tsd.d.ts" /> 

module warsApp.controllers {
    export interface IProcessHeaderConfiguration extends angular.IScope {
        model: models.ProcessHeaderModel ;
    }

    export class ProcessHeaderConfigurationController implements IController {
        scope: IProcessHeaderConfiguration;

        constructor(
            $scope: IProcessHeaderConfiguration,
           processHeaderService: services.ProcessHeaderService,
           $routeParams: angular.route.IRouteParamsService,
           manageStaticDocumentsService: services.ManageStaticDocumentsService,
           treeService: services.TreeService,
           growlService: angular.growl.IGrowlService,
           securityMatrixService: services.SecurityMatrixService) {
            this.scope = $scope;
            var id = $routeParams["id"];
            this.scope.model = new models.ProcessHeaderModel(id, processHeaderService, manageStaticDocumentsService, treeService, growlService,securityMatrixService);
        }
    }
}

warsApp.registerController('ProcessHeaderConfigurationController', ['$scope', 'processHeaderService', '$routeParams', 'manageStaticDocumentsService', 'treeService', 'growl','securityMatrixService' ]);